import { readGraftWebserviceUrl } from '@common/config/utils/read-graft-webservice-url.util'

export const isMembershipsServiceConfigured = () => Boolean(readGraftWebserviceUrl('MEMBERSHIPS'))
